import React from 'react'

import ListVideos from '../../../react4xp/components/ListVideos'

function SocialMediaCardsPart({ title, videos, bgColor, isWhite }) {
    return (
        <ListVideos
            section={{
                bgColor: bgColor,
            }}
            title={title}
            isWhite={isWhite}
            videos={videos}
        />
    )
}

export default (props) => <SocialMediaCardsPart {...props} />
